import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  ThemeProvider,
  Tooltip,
} from "@mui/material";
import { theme } from "../gridToolbarComponents/gridToolbarComponents";
import CloseIcon from "@mui/icons-material/Close";
import Draggable from "react-draggable";
import Paper, { PaperProps } from "@mui/material/Paper";
import React from "react";

interface DecisionDialogBoxProps {
  open: boolean;
  message: string;
  title: string;
  onClose: () => void;
  onConfirm: () => void;
  onContinue?: () => void;
}

function PaperComponent(props: PaperProps) {
  const nodeRef = React.useRef<HTMLDivElement>(null);
  return (
    <Draggable
      nodeRef={nodeRef as React.RefObject<HTMLDivElement>}
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
}

export const DecisionDialogBox = ({
  open,
  message,
  title,
  onClose,
  onConfirm,
  onContinue,
}: DecisionDialogBoxProps) => {
  return (
    <div>
      <ThemeProvider theme={theme}>
        <Dialog
          open={open}
          onClose={(event, reason) => reason !== "backdropClick" && onClose()}
          PaperComponent={PaperComponent}
          aria-labelledby="draggable-dialog-title"
        >
          <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">{title}</DialogTitle>
          <Tooltip title="Close" arrow placement="left">
            <IconButton
              onClick={onClose}
              sx={(theme) => ({
                position: "absolute",
                right: 8,
                top: 8,
                color: "black",
              })}
            >
              <CloseIcon />
            </IconButton>
          </Tooltip>
          <DialogContent>
            <DialogContentText>{message}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={onContinue}
              style={{ textTransform: "none", border: "2px solid #005DAA" }}
              variant="outlined"
            >
              Leave Without Saving
            </Button>
            <Button
              onClick={onConfirm}
              style={{ textTransform: "none" }}
              variant="contained"
            >
              Save Changes
            </Button>
          </DialogActions>
        </Dialog>
      </ThemeProvider>
    </div>
  );
};

export const decisionDialogBoxTitle = "Unsaved Changes";
export const decisionDialogBoxMessage =
  "You have unsaved changes. If you leave now, all changes will be lost. Do you want to save your changes before leaving?";